<template>
  <university-create-form :id="id" :editMode="true"></university-create-form>
</template>

<script>
import UniversityCreateForm from "./CreateForm";
export default {
  name: "EditUniversityPage",
  components: { UniversityCreateForm },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = this.$route.params.id;
  }
};
</script>

<style scoped></style>
